(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["antiguo-room"]) return;
  try {
    
document.querySelectorAll('.antiguo-room-page__nav').forEach(nav => {
  const toggles = [...nav.querySelectorAll('.antiguo-collection-nav__toggle')];
  const closePanels = () => {
    toggles.forEach(toggle => {
      toggle.setAttribute('aria-expanded', 'false');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  };
  toggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      closePanels();
      if (!wasOpen) {
        toggle.setAttribute('aria-expanded', 'true');
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (panel) panel.hidden = false;
      }
    });
  });
  nav.addEventListener('keydown', event => {
    if (event.key === 'Escape') closePanels();
  });
  nav.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse') closePanels(); });
  document.addEventListener('click', event => { if (!nav.contains(event.target)) closePanels(); });
});
const currentRoom = document.querySelector('.antiguo-room-page')?.dataset.antiguoRoom;
if (currentRoom === 'wir') {
  const wirLink = document.querySelector('#header-component a.menu-list__link[href*="view=haus-wir"]');
  if (wirLink) wirLink.classList.add('antiguo-room-current');
}
const museumPage = document.querySelector('.antiguo-room-page[data-antiguo-room="museum"]');
if (museumPage) {
  const welcome = museumPage.querySelector('.antiguo-museum-welcome');
  const archive = museumPage.querySelector('[data-museum-archive]');
  const cards = [...museumPage.querySelectorAll('[data-museum-card]')];
  const title = archive.querySelector('[data-museum-archive-title]');
  const empty = archive.querySelector('[data-museum-archive-empty]');
  const updateMuseumArchive = () => {
    const hash = window.location.hash.slice(1);
    const prefix = 'museum-filter=';
    const filter = hash.startsWith(prefix) ? decodeURIComponent(hash.slice(prefix.length)) : '';
    if (!filter) {
      archive.hidden = true;
      welcome.hidden = false;
      return;
    }
    welcome.hidden = true;
    archive.hidden = false;
    const selectedLink = [...museumPage.querySelectorAll('[data-museum-filter-link]')].find(link => link.dataset.museumFilterLink === filter);
    title.textContent = filter === 'all' ? archive.dataset.allTitle : (selectedLink ? selectedLink.textContent.trim() : archive.dataset.collectionTitle);
    let visibleCount = 0;
    cards.forEach(card => {
      const measures = (card.dataset.measures || '').split(',').filter(Boolean);
      const form = card.dataset.form || '';
      const matches = filter === 'all'
        || card.dataset.era === filter
        || form === filter
        || measures.includes(filter)
        || (filter === 'kamin-buffetuhren' && (form === 'kaminuhr' || form === 'buffetuhr'));
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    });
    empty.hidden = visibleCount > 0;
    window.requestAnimationFrame(() => archive.scrollIntoView({ behavior: 'smooth', block: 'start' }));
  };
  window.addEventListener('hashchange', updateMuseumArchive);
  updateMuseumArchive();
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["heimatseite"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const wirLink = document.querySelector('#header-component a.menu-list__link[href*="view=haus-wir"]');
    if (wirLink) wirLink.classList.add('antiguo-room-current');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;
    document.querySelectorAll('.heimat-tile__scene[data-heimat-gallery]').forEach((gallery) => {
      if (gallery.dataset.rotationReady === 'true') return;
      gallery.dataset.rotationReady = 'true';
      const slides = Array.from(gallery.querySelectorAll('.heimat-tile__image'));
      if (slides.length < 2) return;
      let active = 0;
      window.setInterval(() => {
        slides[active].classList.remove('is-active');
        slides[active].setAttribute('aria-hidden', 'true');
        active = (active + 1) % slides.length;
        slides[active].classList.add('is-active');
        slides[active].removeAttribute('aria-hidden');
      }, 6500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["museum-exhibit"]) return;
  try {
    
  document.querySelectorAll('[data-museum-gallery]').forEach((gallery) => {
    const hero = gallery.querySelector('.museum-exhibit__hero');
    const thumbs = gallery.querySelectorAll('[data-museum-thumb]');
    const openButton = gallery.querySelector('[data-museum-open-image]');
    const lightbox = gallery.querySelector('[data-museum-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-museum-lightbox-image]');
    const closeButton = lightbox?.querySelector('[data-museum-close]');
    const backLinks = gallery.querySelectorAll('[data-museum-back]');
    try {
      const previousPage = new URL(document.referrer);
      if (previousPage.origin === window.location.origin) {
        backLinks.forEach((link) => {
          link.addEventListener('click', (event) => {
            event.preventDefault();
            window.history.back();
          });
        });
      }
    } catch (error) {
      // Keep the collection link as a fallback for direct visits.
    }
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!hero) return;
        hero.removeAttribute('srcset');
        hero.src = thumb.getAttribute('data-image-1200');
        hero.dataset.imageLarge = thumb.getAttribute('data-image-large');
        hero.alt = thumb.dataset.imageAlt;
        thumbs.forEach((item) => item.setAttribute('aria-pressed', String(item === thumb)));
      });
    });
    openButton?.addEventListener('click', () => {
      if (!hero || !lightbox || !lightboxImage) return;
      lightboxImage.src = hero.dataset.imageLarge || hero.src;
      lightboxImage.alt = hero.alt;
      lightbox.showModal();
    });
    closeButton?.addEventListener('click', () => lightbox?.close());
    lightbox?.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
